export enum UnderReviewWithdrawalOptions {
    'YES' = 'forms.buttons.yes',
    'NO' = 'forms.buttons.no'
  }
